

<template>
  <div>
    <div class="baic_content">
      <h3></h3>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">课件名称:</h5>
        <p>
          {{ $parent.$parent.videoinfo.CoursewareName }}
        </p>
      </div>
      <div class="bacle_input" v-else>
        <h5 class="vip_view">课件名称:</h5>
        <el-input
          type="textarea"
          placeholder="请输入课件名称"
          v-model.trim="textarea"
          maxlength="30"
          show-word-limit
          resize="none"
          class="check_textarea"
          :disabled="isedite == 1"
        >
        </el-input>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">上传课件:</h5>
        <p>
          {{ $parent.$parent.videoinfo.CoursewareName + "课件" }}
        </p>
      </div>
      <div class="bacle_input" v-if="isedite == 0">
        <h5 class="vip_view">上传课件:</h5>
        <el-input
          :placeholder="filename"
          class="check_input"
          v-model="textFile"
          readonly
        ></el-input>
        <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          multiple
          :limit="1"
          :show-file-list="false"
          :on-change="uploadPreview"
          :auto-upload="false"
        >
          <el-button type="primary" icon="el-icon-upload2" class="upoload"
            >上传文件</el-button
          >
        </el-upload>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">课件开放时间:</h5>
        <p>
          {{
            opentime(
              $parent.$parent.videoinfo.BeginTime,
              $parent.$parent.videoinfo.EndTime
            )
          }}
        </p>
      </div>
      <div class="bacle_input" v-else>
        <h5 class="vip_view">课件开放时间:</h5>
        <el-date-picker
          :disabled="isedite == 2"
          class="datescope"
          v-model="value1"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="$route.query.trainId ? pickerOptions : pickerOptions0"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @focus="obtainTime"
          :default-time="[vehicleTime, '23:59:00']"
        >
        </el-date-picker>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">格式大小:</h5>
        <p>
          {{
            filesize(
              $parent.$parent.videoinfo.Format,
              $parent.$parent.videoinfo.FileSize
            )
          }}
        </p>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">上传时间:</h5>
        <p>
          {{
            $moment($parent.$parent.videoinfo.CreateTime).format(
              "YYYY/MM/DD HH:mm"
            )
          }}
        </p>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">上传者:</h5>
        <p>
          {{ $parent.$parent.videoinfo.RealName }}
        </p>
      </div>
      <div class="bacle_input">
        <h5 class="mg_40">课件简介:</h5>
        <el-input
          type="textarea"
          placeholder="请输入课件名称"
          v-model.trim="textproduce"
          maxlength="500"
          show-word-limit
          resize="none"
          class="check_produce"
          :readonly="isedite == 2"
        >
        </el-input>
      </div>
      <div class="learning_time" v-if="!$route.query.trainId">
        <h5 class="vip_view">课件最低学习时长要求:</h5>
        <div class="input_time">
          <el-input
            v-model.number="timeValue"
            placeholder="请输入课件学习时长"
          ></el-input>
          <p>
            <span>分钟</span
            >（学习时长低于要求将不被记录。设置为0则不开启限制。）
          </p>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="back">返回</el-button>
        <el-button type="success" class="submit_btn" @click="next">{{
          $route.query.trainId ? "完成" : "下一步"
        }}</el-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 进度条 -->
    <el-dialog
      title="提示"
      :visible.sync="progressdialog.isshow"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="parseFloat(progressdialog.percentagenum.toFixed(2))"
        status="success"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss"; //引入oss
import training from "@/api/trainingApi";
import resourcereq from "@/api/resources";
export default {
  data() {
    return {
      textarea: "", //
      input1: "", //
      input2: "", //
      isedite: 0,
      isShow: false,
      filename: "支持 doc、docx、xls、xlsx、ppt、pptx、txt、pdf 文件格式上传", //当前的文件名
      textFile: "", // 文件上传文件名
      value1: [], //范围时间数组
      textproduce: "", //课件介绍。
      database: "", //课件的basedata数据
      vehicleTime: "23:59:00", // 默认时分秒
      timeValue: 0, // 学习最低时长
      getData: "",
      progressdialog: {
        isshow: false,
        percentagenum: 0,
      }, //进度弹窗
      client: null, //oss对象
      pickerOptions: {
        //禁用当前前面的时间日期
        disabledDate(time) {
          // 培训的限制
          const row = JSON.parse(localStorage.getItem("examRowTime"));
          if (row.begainTime) {
            const begainTime = row.begainTime;
            const endTime = row.endTime;
            return   time.getTime() < new Date(begainTime).getTime() ||time.getTime() > new Date(endTime).getTime()
          }
        },
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  methods: {
    back() {
      this.$parent.back();
    },
    numberChange() {
      if (typeof this.timeValue !== "number") {
        this.$message({
          message: "警告，课件学习时长做必须为数字，单位为分钟",
          type: "warning",
        });
        this.timeValue = 0;
      }
    },
    async next() {
      //下一步
      if (this.textarea == "") {
        this.$message.error("课件名称不能为空");
        return;
      }
      if (this.$parent.reqfrom.file.length == 0 && this.isedite == 0) {
        this.$message.error("上传文件不能为空");
        return;
      }
      if (this.value1.length == 0) {
        this.$message.error("课件开放时间不能为空");
        return;
      }
      if (String(this.timeValue) == "") {
        this.timeValue = 0;
        this.$message.error("课件学习时长要求不能为空");
        return;
      }

      this.$parent.reqfrom.BeginTime = this.value1[0];
      this.$parent.reqfrom.EndTime = this.value1[1];
      this.$parent.reqfrom.CoursewareName = this.textarea;
      this.$parent.reqfrom.CoursewareExplain = this.textproduce;
      this.$parent.reqfrom.CoursewareExplain = this.textproduce;
      this.$parent.reqfrom.bitData = this.database;
      this.$parent.reqfrom.floorTime = this.timeValue;
      if (this.$route.query.trainId) {
        // 培训进来的
        const obj = {
          trainId: this.$route.query.trainId,
        };
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.getData = data.Data.studentArr.map((item) => {
            item.UserID = item.StudentID;
            return item;
          });
          if (this.$route.query.state == 0) {
            // 去添加
            // console.log(this.$parent.$parent.videoinfo);
            let selectid = this.getData.map((item) => {
              return item.UserID;
            });
            this.$parent.reqfrom.userArr = JSON.stringify(selectid);
            let status = await this.checkfilename();
            if (status == 200) {
              this.createOSS();
              setTimeout(() => {
                this.sundflag = false;
              }, 500);
            } else if (status == 201) {
              this.$message({
                message: "视频名称已存在，请重新命名",
                type: "warning",
              });
              this.sundflag = false;
            } else {
              this.$message({
                message: "服务器出错了",
                type: "warning",
              });
              this.sundflag = false;
            }
          } else {
            // 编辑
            this.savevideo();
            this.$message("修改成功");
            this.$router.push({
              path: "manage",
              query: {
                trainId: this.$route.query.trainId,
                // typeId: id,
              },
            });
          }
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.$parent.cutcoms(1);
      }
    },
    savevideo() {
      //修改视频信息，
      let selectid = this.getData.map((item) => {
        return item.UserID;
      });
      this.$parent.reqfrom.userArr = JSON.stringify(selectid);
      this.$parent.reqfrom.CoursewareID =
        this.$parent.$parent.videoinfo.CoursewareID;
      resourcereq.SaveCoursewareInfo(this.$parent.reqfrom);
    },
    // 点击获取当前默认时间
    obtainTime() {
      this.vehicleTime = this.$moment().format("HH:mm:ss");
    },
    async checkfilename() {
      let parmas = {
        name: this.textarea,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      let res = await resourcereq.checkfilename(parmas);
      return res.data.Status;
    },
    async createOSS() {
      //这里面进行请求sts
      let parmas = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      // let ressts = await resourcereq.getOSS_STS(parmas);
      let ressts = await resourcereq.getCoursewareOSS_STS(parmas);
      if (ressts.data.Status == 200 && ressts.data.Data.AccessKeyId) {
        // 上传前校验是否上传过，通过过校验服务器容量
        // const res = await getstudentlist.getUploadSTSAuth(parmas);
        // console.log(res, "2024");
        this.client = new OSS({
          region: "oss-cn-shenzhen",
          accessKeyId: ressts.data.Data.AccessKeyId,
          accessKeySecret: ressts.data.Data.AccessKeySecret,
          bucket: "yingedu-video4",
          stsToken: ressts.data.Data.SecurityToken,
          secure: true,
        });
        this.ossUpload(this.$parent.reqfrom.OSSUrl, this.$parent.reqfrom.file);
      } else {
        this.$message.error(ressts.data.Data);
      }
      return;
      // let res = await resourcereq.createCourseware(this.$parent.reqfrom);
      // if (res.data.Status == 200) {
      //   this.$parent.back();
      //   this.$message({
      //     message: "上传成功",
      //     type: "success",
      //   });
      // }
    },
    async ossUpload(filename, file) {
      //获取拿到的oss对象进行发送请求。
      let _this = this;
      this.progressdialog.isshow = true;
      try {
        let result = await _this.client.multipartUpload(filename, file, {
          //OSS的实例方法执行，第一个参数是文件名，第二个文件对象，第三个是一个对象，对象内的属性表示上传的过程。
          //        表示进度回调函数，用于获取上传进度，可以是async的函数形式。回调函数包含三个参数：
          //percentage {Number}：进度百分比（0~1之间的小数）。
          //checkpoint {Object}：与[options] {Object}中的[checkpoint] {Object}定义相同。
          //res {Object}：单个分片上传成功返回的response。
          progress: async function (p, checkpoint) {
            _this.checkpoint = checkpoint;
            _this.progressdialog.percentagenum = p * 100;
            if (p == 1) {
              const { data } = await resourcereq.createCourseware(
                _this.$parent.reqfrom
              );
              if ((data.Status = 200)) {
                _this.progressdialog.isshow = false;
                _this.$message({
                  message: "上传成功",
                  type: "success",
                });
                if (data.Data.coursewareID) {
                  _this.addTrainBy(data.Data.coursewareID);
                }
                _this.$parent.back();
              } else {
                this.$message.error(data.Data);
              }
            }
          },
          checkpoint: _this.checkpoint,
        });
      } catch (e) {}
    },
    async addTrainBy(ID) {
      const obj = {
        trainId: this.$route.query.trainId,
        type: this.$route.query.type,
        typeId: ID,
      };
      const { data } = await training.addTrainByID(obj);
      if (data.Status == 200) {
        _this.$router.push({
          path: "manage",
          query: {
            trainId: this.$route.query.trainId,
            typeId: ID,
          },
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    async init() {
      if (this.$route.query.state == 0) {
        // 新增
        let params = {
          // VideoName: "", // 视频名称查询
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          url: "/api/courseware/VideoManage/getVideoList",
          UserID: JSON.parse(localStorage.getItem("userlist")).userID,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          pageIndex: 0,
          pageCount: 10,
          keyStr: ".show.bottom",
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        const { data } = await resourcereq.getCoursewareList(params);
        if (data.Status == 200) {
          this.$parent.surplus =
            data.Data.result[3][0].courseSize - data.Data.result[1].countFile;
        }
        console.log(data);
      }
    },
    uploadPreview(file) {
      //文件上传，增加进度条，
      this.textFile = file.name;
      let filetype = file.name.split(".");
      filetype = filetype[filetype.length - 1]; //文件类型。
      this.$parent.reqfrom.Format = filetype;
      if (
        filetype != "doc" &&
        filetype != "docx" &&
        filetype != "xls" &&
        filetype != "xlsx" &&
        filetype != "ppt" &&
        filetype != "pptx" &&
        filetype != "txt" &&
        filetype != "pdf"
      ) {
        this.$message({
          message: "文件格式不合法",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      } else if (file.raw.size > 104857600) {
        this.$message({
          message: "文件大小不能超过100MB",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles();
        return;
      } else if (file.raw.size > this.$parent.surplus) {
        // 4.11 产品更改可用容量不够上传前端拦截
        let str = this.$parent.surplus / 1024 / 1024;
        this.$message.error(
          `课件文件大小已超出容量,当前仅剩${str.toFixed(0)}M容量!`
        );
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      }
      //开始进行base64转码
      let fullname = file.raw.name.substring(
        0,
        file.raw.name.length - filetype.length - 1
      );
      this.$parent.reqfrom.OSSUrl = `tibosi/${
        JSON.parse(localStorage.getItem("userlist")).hid
      }/${fullname}.${filetype}`;
      this.$parent.reqfrom.file = file.raw;
      this.$parent.reqfrom.FileSize = file.raw.size;
      this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
    },
  },
  computed: {
    filesize() {
      return function (Format, size) {
        size = (size / (1024 * 1024)).toFixed(3);
        return Format + "/" + size + "M";
      };
    },
    opentime() {
      return function (bigintime, endtime) {
        bigintime = this.$moment(bigintime).format("YYYY/MM/DD HH:mm");
        endtime = this.$moment(endtime).format("YYYY/MM/DD HH:mm");
        return bigintime + "-" + endtime;
      };
    },
  },
  activated() {
    this.init();
  },
  created() {
    if (this.$parent.$parent.videoinfo != "kong") {
      if (this.$parent.$parent.details == "details") {
        this.isedite = 2;
      } else {
        this.isedite = 1;
      }
      this.timeValue = this.$parent.$parent.videoinfo.floorTime;
      this.textarea = this.$parent.$parent.videoinfo.CoursewareName;
      this.value1[0] = this.$moment(
        this.$parent.$parent.videoinfo.BeginTime
      ).format("YYYY-MM-DD HH:mm");
      this.value1[1] = this.$moment(
        this.$parent.$parent.videoinfo.EndTime
      ).format("YYYY-MM-DD HH:mm");
      this.textproduce = this.$parent.$parent.videoinfo.CoursewareExplain;
    }
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 20px;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  .vip_view {
    display: inline-block;
    min-width: 142px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  .mg_40 {
    // padding-left: 14px !important;
    padding-left: 40px !important;
    text-align: right;
  }
  .back_view {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
    }
  }
  .learning_time {
    display: flex;
    // align-items: center;
    margin-top: 30px;
    // padding-right: 40px;
    .input_time {
      display: flex;
      align-items: center;
      .el-input {
        width: 100px;
        margin-left: 4px;
      }
      p {
        span {
          margin: 0px 4px;
        }
      }
    }
  }
  .bacle_input {
    display: flex;
    // align-items: center;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      // min-width: 142px;
      min-width: 164px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      // &::before {
      //   content: "*";
      //   width: 20px;
      //   display: inline-block;
      //   color: #ff0000;
      // }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_produce {
    width: 832px;
    height: 200px;
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 141px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}
.upoload {
  color: #1890ff !important;
  background-color: rgb(255, 255, 255) !important;
}
.datescope {
  width: 825px;
}
::v-deep .el-textarea__inner {
  height: 200px;
}
</style>
